import { render, staticRenderFns } from "./ApiSettings.vue?vue&type=template&id=26bf4be1&scoped=true"
import script from "./ApiSettings.vue?vue&type=script&lang=js"
export * from "./ApiSettings.vue?vue&type=script&lang=js"
import style0 from "./ApiSettings.vue?vue&type=style&index=0&id=26bf4be1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bf4be1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26bf4be1')) {
      api.createRecord('26bf4be1', component.options)
    } else {
      api.reload('26bf4be1', component.options)
    }
    module.hot.accept("./ApiSettings.vue?vue&type=template&id=26bf4be1&scoped=true", function () {
      api.rerender('26bf4be1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/ApiSettings.vue"
export default component.exports